export function store_user_setting({ commit }, payload){
    // commit all other settings for simple things other then schools
    // which also is a stored value
    commit('STORE_USER_SETTING', payload);
}